// @flow
import React, { Component } from 'react';
import { AccountDiv } from './AccountStyles';
import HeaderBlock from './HeaderBlock';
import { Route } from 'react-router-dom';
import AccountInformation from './Information';
import CryptoWallets from './CryptoWallets';
import BankAccount from './BankAccount';

type Props = {};

export default class Account extends Component<Props> {
  render() {
    return (
      <AccountDiv>
        <HeaderBlock />
        <Route exact path="/account" component={AccountInformation} />
        <Route exact path="/account/bank-account" component={BankAccount} />
        <Route exact path="/account/crypto-wallets" component={CryptoWallets} />
      </AccountDiv>
    );
  }
}
